// French translations
export const fr = {
  // Header
  header: {
    title: 'Laboratoire MicroGPT',
    subtitle: 'Apprenez microgpt de manière interactive',
    level: 'Niveau',
    params: 'paramètres',
    badges: 'badges',
    train: 'Entraîner',
    star: 'Étoile'
  },

  // Navigation
  nav: {
    curriculum: 'Programme',
    content: 'Contenu',
    visualization: 'Visualisation'
  },

  // Levels
  levels: {
    completed: 'Terminé',
    locked: 'Verrouillé',
    current: 'Niveau Actuel'
  },

  // Buttons
  buttons: {
    complete: 'Terminer le Niveau',
    startLearning: 'Commencer à Apprendre',
    trainAgain: 'Réentraîner',
    reset: 'Réinitialiser',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'OK',
    showHint: 'Afficher l\'Indice',
    showSolution: 'Afficher la Solution',
    runCheck: 'Exécuter et Vérifier',
    randomize: 'Aléatoiriser'
  },

  // Training Experience
  training: {
    title: 'Entraîner MicroGPT',
    intro: 'Regardez un modèle de langage s\'entraîner et générer du texte en temps réel',
    starting: 'Démarrage de l\'entraînement...',
    training: 'Entraînement en cours...',
    generating: 'Génération d\'échantillons...',
    complete: 'Entraînement Terminé !',
    lossLabel: 'Perte',
    stepLabel: 'Étape',
    generatedNames: 'Noms Générés (Hallucinés !)',
    explanation: 'Ces noms ont été hallucinés par le modèle - il ne les a jamais vus auparavant !',
    pipeline: 'Le Pipeline Complet de MicroGPT',
    comparison: 'De Cette Démo à ChatGPT',
    thisDemo: 'Cette Démo',
    chatgpt: 'ChatGPT',
    sameAlgorithm: 'Même algorithme, échelle différente !'
  },

  // About Dialog
  about: {
    title: 'À Propos de MicroGPT',
    subtitle: 'L\'essence des grands modèles de langage',
    whatIs: 'Qu\'est-ce que MicroGPT ?',
    whatIsDesc: 'MicroGPT est une implémentation minimale d\'un modèle de langage de style GPT...',
    whatYoullLearn: 'Ce que Vous Apprendrez',
    fromMicroToMega: 'Du Micro au Méga',
    chatgptConnection: 'La Connexion ChatGPT',
    resources: 'Ressources',
    resetProgress: 'Réinitialiser Toute la Progression',
    resetProgressDesc: 'Effacer tous les niveaux terminés et badges obtenus',
    resetConfirm: 'Êtes-vous sûr de vouloir réinitialiser toute la progression ? Cela effacera les niveaux terminés et les badges obtenus.'
  },

  // Code Exercise
  exercise: {
    description: 'Description',
    template: 'Modèle de Code',
    hint: 'Indice',
    solution: 'Solution',
    useSolution: 'Utiliser cette solution',
    attempts: 'tentative',
    attemptsPlural: 'tentatives',
    checking: 'Vérification...',
    loading: 'Chargement de l\'environnement Python...',
    testPassed: 'Test réussi',
    testFailed: 'Test échoué',
    allTestsPassed: 'Tous les tests réussis !',
    someTestsFailed: 'Certains tests ont échoué',
    tabSpaces: 'Tab = 4 espaces'
  },

  // Notifications
  notifications: {
    badgeEarned: 'Badge obtenu',
    levelComplete: 'Niveau terminé !',
    readyToLearn: 'Prêt à apprendre comment ça fonctionne !'
  },

  // Theme
  theme: {
    chooseTheme: 'Choisir le Thème',
    selectScheme: 'Sélectionnez votre schéma de couleurs préféré',
    dark: 'Sombre',
    light: 'Clair'
  },

  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Information'
  }
};
